<template>
  <PaginationAndViewMore
    v-ga-section-view
    class="guide-contents"
    data-section-name="Contents"
    data-section-number="2"
    :items="store.currentGuides"
    :settings="{
      initialRevealNumber: { mobile: 14, tablet: 15 },
      revealNumberPerClick: { mobile: 6, tablet: 6 },
      itemsPerPage: 12,
      maxPagination: 5,
    }"
  >
    <template #body="{ item }">
      <ListItemBox
        v-if="item.youtubeId"
        v-ga-event="{
          interaction: 'content_click',
          sectionContent: item.name,
        }"
        aspect-ratio="364/280"
        :image="item.thumbnail"
        :title="item.name"
        class="video-item"
        @click="
          () => {
            youtubeIDForDialog = item.youtubeId
            dialog = true
          }
        "
      />
      <ListItemBox
        v-else
        v-ga-event="{
          interaction: 'content_click',
          sectionContent: item.name,
        }"
        aspect-ratio="364/280"
        :image="item.thumbnail"
        :route-to="
          findMenu(kebabCase(item.name)) ?? {
            name: 'maple-guide-detail',
            params: { category: $route.params.category, id: item.id, seoTitle: kebabCase(item.name) },
          }
        "
        :title="item.name"
      />
    </template>
  </PaginationAndViewMore>
  <DialogBox v-model="dialog" :video-ratio="true">
    <YoutubeCom :id="youtubeIDForDialog" auto-play controls />
  </DialogBox>
</template>
<script setup lang="ts">
  import { useMapleGuideStore } from '@/store/MapleGuide'
  import { kebabCase } from 'change-case'
  import { FlatMenuList } from '@/router/routes'

  const dialog = ref(false)
  const youtubeIDForDialog = ref('')

  function findMenu(itemPath: string) {
    const menu = FlatMenuList.find((x) => x.path === itemPath)
    if (menu !== undefined) {
      return {
        name: menu.name,
      }
    }
    return null
  }

  const store = useMapleGuideStore()
</script>
<style lang="scss">
  .guide-contents {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: var(--default-grid-gap);
  }

  .video-item {
    cursor: pointer;
    &::after {
      content: '';
      position: absolute;
      width: 40%;
      height: 40%;
      top: 30%;
      left: 30%;
      background-image: url('@/assets/svgs/video-play.svg');
      background-size: contain;
      background-position: center;
    }
  }

  @media #{$tablet} {
    .guide-contents {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 10px;
    }
  }
  @media #{$mobile} {
    .guide-contents {
      grid-template-columns: repeat(2, 1fr);
    }
  }
</style>
